(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["key-specs"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".tabs-switcher").forEach(section => {
    const buttons = section.querySelectorAll(".tabs-switcher__button");
    const items = section.querySelectorAll(".tabs-switcher__item");

    buttons.forEach(btn => {
      btn.addEventListener("click", () => {
        const index = btn.dataset.tabIndex;

        buttons.forEach(b => b.classList.remove("is-active"));
        items.forEach(i => i.classList.remove("is-active"));

        btn.classList.add("is-active");
        const target = section.querySelector(`.tabs-switcher__item[data-tab-index="${index}"]`);
        if (target) target.classList.add("is-active");
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-manuals"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Add click event listeners to all vehicle model blocks
    const vehicleBlocks = document.querySelectorAll('.vehicle-model-block[data-modal-id]');
    vehicleBlocks.forEach(function (block) {
      block.addEventListener('click', function () {
        const modalId = this.dataset.modalId;
        openManualModal(modalId);
      });

      // Add keyboard support
      block.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          const modalId = this.dataset.modalId;
          openManualModal(modalId);
        }
      });
    });

    // Add click event listeners to close buttons
    const closeButtons = document.querySelectorAll('.product-manual-modal__close');
    closeButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        const modalId = this.dataset.modalId;
        closeManualModal(modalId);
      });
    });

    // Add click event listeners to overlay
    const overlays = document.querySelectorAll('.product-manual-modal__overlay');
    overlays.forEach(function (overlay) {
      overlay.addEventListener('click', function () {
        const modalId = this.dataset.modalId;
        closeManualModal(modalId);
      });
    });
  });

  function openManualModal(modalId) {
    const modal = document.getElementById(modalId);
    if (modal) {
      modal.style.display = 'block';
      document.body.style.overflow = 'hidden';
    }
  }

  function closeManualModal(modalId) {
    const modal = document.getElementById(modalId);
    if (modal) {
      modal.style.display = 'none';
      document.body.style.overflow = '';
    }
  }

  // Close modal on escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      const openModal = document.querySelector('.product-manual-modal[style*="block"]');
      if (openModal) {
        closeManualModal(openModal.id);
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
